// <tw-topo> — slowly drifting topographic contour lines. Attributes: color, accent, speed, scale.
(function () {
  if (customElements.get('tw-topo')) return;
  const P = new Uint8Array(512);
  (function () {
    const p = [...Array(256).keys()];
    let s = 7;
    for (let i = 255; i > 0; i--) {
      s = (s * 16807) % 2147483647;
      const j = s % (i + 1);
      [p[i], p[j]] = [p[j], p[i]];
    }
    for (let i = 0; i < 512; i++) P[i] = p[i & 255];
  })();
  const fade = (t) => t * t * t * (t * (t * 6 - 15) + 10),
    lerp = (a, b, t) => a + t * (b - a);
  function grad(h, x, y, z) {
    const u = h < 8 ? x : y,
      v = h < 4 ? y : h === 12 || h === 14 ? x : z;
    return (h & 1 ? -u : u) + (h & 2 ? -v : v);
  }
  function noise(x, y, z) {
    const X = Math.floor(x) & 255,
      Y = Math.floor(y) & 255,
      Z = Math.floor(z) & 255;
    x -= Math.floor(x);
    y -= Math.floor(y);
    z -= Math.floor(z);
    const u = fade(x),
      v = fade(y),
      w = fade(z);
    const A = P[X] + Y,
      AA = P[A] + Z,
      AB = P[A + 1] + Z,
      B = P[X + 1] + Y,
      BA = P[B] + Z,
      BB = P[B + 1] + Z;
    return lerp(
      lerp(
        lerp(grad(P[AA] & 15, x, y, z), grad(P[BA] & 15, x - 1, y, z), u),
        lerp(grad(P[AB] & 15, x, y - 1, z), grad(P[BB] & 15, x - 1, y - 1, z), u),
        v,
      ),
      lerp(
        lerp(grad(P[AA + 1] & 15, x, y, z - 1), grad(P[BA + 1] & 15, x - 1, y, z - 1), u),
        lerp(grad(P[AB + 1] & 15, x, y - 1, z - 1), grad(P[BB + 1] & 15, x - 1, y - 1, z - 1), u),
        v,
      ),
      w,
    );
  }
  class TwTopo extends HTMLElement {
    connectedCallback() {
      this.style.display = 'block';
      this.style.width = '100%';
      this.style.height = '100%';
      this.style.overflow = 'hidden';
      this.c = document.createElement('canvas');
      this.c.style.cssText = 'display:block;width:100%;height:100%';
      this.c.setAttribute('aria-hidden', 'true');
      this.appendChild(this.c);
      this.ctx = this.c.getContext('2d');
      this.t0 = performance.now();
      this.visible = true;
      this.last = 0;
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.ro = new ResizeObserver(() => this.resize());
      this.ro.observe(this);
      this.io = new IntersectionObserver((e) => {
        this.visible = e[0].isIntersecting;
      });
      this.io.observe(this);
      const loop = (now) => {
        this.raf = requestAnimationFrame(loop);
        if (!this.visible || this.reduce) return;
        if (now - this.last < 40) return;
        this.last = now;
        this.draw(now);
      };
      this.raf = requestAnimationFrame(loop);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      this.ro && this.ro.disconnect();
      this.io && this.io.disconnect();
    }
    resize() {
      const r = this.getBoundingClientRect(),
        d = Math.min(2, devicePixelRatio || 1);
      if (!r.width || !r.height) return;
      this.w = r.width;
      this.h = r.height;
      this.c.width = Math.round(r.width * d);
      this.c.height = Math.round(r.height * d);
      this.ctx.setTransform(d, 0, 0, d, 0, 0);
      this.draw(performance.now());
    }
    draw(now) {
      if (!this.w) return;
      const ctx = this.ctx,
        W = this.w,
        H = this.h,
        cell = 9;
      const speed = Number.parseFloat(this.getAttribute('speed') || '1'),
        sc = Number.parseFloat(this.getAttribute('scale') || '1');
      const t = ((now - this.t0) / 1000) * 0.035 * speed + 3.1;
      const color = this.getAttribute('color') || 'rgba(62,75,91,.14)',
        accent = this.getAttribute('accent') || 'rgba(4,123,248,.32)';
      const cols = Math.ceil(W / cell) + 1,
        rows = Math.ceil(H / cell) + 1,
        f = new Float32Array(cols * rows),
        k = 0.0032 / sc;
      for (let j = 0; j < rows; j++)
        for (let i = 0; i < cols; i++) {
          const x = i * cell * k,
            y = j * cell * k;
          f[j * cols + i] = noise(x, y, t) + 0.45 * noise(x * 2.1 + 9, y * 2.1, t * 1.3);
        }
      ctx.clearRect(0, 0, W, H);
      ctx.lineWidth = 1;
      ctx.lineJoin = 'round';
      const N = 18;
      for (let l = 0; l < N; l++) {
        const lv = -0.9 + (1.8 * l) / (N - 1),
          major = l % 5 === 2;
        ctx.strokeStyle = major ? accent : color;
        ctx.lineWidth = major ? 1.25 : 1;
        ctx.beginPath();
        for (let j = 0; j < rows - 1; j++)
          for (let i = 0; i < cols - 1; i++) {
            const a = f[j * cols + i],
              b = f[j * cols + i + 1],
              c = f[(j + 1) * cols + i + 1],
              d = f[(j + 1) * cols + i];
            const idx = (a > lv ? 8 : 0) | (b > lv ? 4 : 0) | (c > lv ? 2 : 0) | (d > lv ? 1 : 0);
            if (idx === 0 || idx === 15) continue;
            const x = i * cell,
              y = j * cell;
            const T = [x + (cell * (lv - a)) / (b - a), y],
              R = [x + cell, y + (cell * (lv - b)) / (c - b)],
              B = [x + (cell * (lv - d)) / (c - d), y + cell],
              L = [x, y + (cell * (lv - a)) / (d - a)];
            const seg = (p, q) => {
              ctx.moveTo(p[0], p[1]);
              ctx.lineTo(q[0], q[1]);
            };
            switch (idx) {
              case 1:
              case 14:
                seg(L, B);
                break;
              case 2:
              case 13:
                seg(B, R);
                break;
              case 3:
              case 12:
                seg(L, R);
                break;
              case 4:
              case 11:
                seg(T, R);
                break;
              case 5:
                seg(L, T);
                seg(B, R);
                break;
              case 6:
              case 9:
                seg(T, B);
                break;
              case 7:
              case 8:
                seg(L, T);
                break;
              case 10:
                seg(T, R);
                seg(L, B);
                break;
            }
          }
        ctx.stroke();
      }
    }
  }
  customElements.define('tw-topo', TwTopo);
})();
